import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function AuditlogReducer(state = initialState.auditlogContent, action: any) {
  switch (action.type) {
    case types.SAVE_AUDITLOGCONTENT_SUCCESS:
      return action.auditlogContent;
    default:
      return state;
  }
}
